import React from "react";

function Loading() {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    color: "#555",
  };

  const spinnerStyle = {
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #0066ff",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    animation: "spin 1s linear infinite",
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={containerStyle}>
        <div style={spinnerStyle}></div>
        <p style={{ marginTop: "20px", fontSize: "16px" }}>Loading news...</p>
      </div>
    </>
  );
}

export default Loading;
